
import type { PropOptions } from 'vue';
import Vue from 'vue';
import PublicPortfolioModal from '~/components/partials/public-portfolio/PublicPortfolioModal.vue';
import BravadoButtonV3 from '~/components/common/BravadoButtonV3/BravadoButtonV3.vue';

export default Vue.extend({
  name: 'PublicPortfolioTestimonialModal',
  components: { PublicPortfolioModal, BravadoButtonV3 },
  props: {
    authorName: {
      type: String,
      required: true,
    } as PropOptions<string>,
    testimonialText: {
      type: String,
      required: true,
    } as PropOptions<string>,
  },
  computed: {
    title(): string {
      return `${this.authorName}’s testimonial`;
    },
  },
});
